<template>
  <v-container>
    <div v-if="brandbar_show">
      <!--//@*/*
    //    *BCS   App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

      <!-- Header -->
      <v-row
        cols="12 col-lg-12"
        id="v-app-bar--container"
        class="city-header flex-row nowrap justify-start pa-2 pt-0"
      >
        <v-col cols="2" class="flex-item-1 pr-0 col-md-1">
          <a href="https://renopd.com/ " title="Reno PD .com">
            <img src="../images/gold-badge.png" class="pl-2 md-pl-0"
          /></a>
        </v-col>
        <v-col
          cols="7"
          class="flex-item-2 col-md-7 col-lg-10 white--text ml-md-8 ml-lg-n8 pt-md-5 pl-2 pl-lg-0 pt-4"
        >
          <div class="mb-0">THE RENO</div>
          <div class="mb-0">POLICE DEPARTMENT</div>
          <div class="font-italic mb-0">Your Police, Our Community</div>
        </v-col>

        <!-- Join buttons md and up -->
        <v-col
          class="col-md-1 col-lg-auto pr-lg-0 join-us join-1 hidden-sm-and-down"
        >
          <a
            href="https://renopd.com/Recruit"
            style="background-color: #4587c1 !important"
            class="btn waves-effect mr-2 px-2 white--text"
            target="_blank"
            title="Join Our Team"
            >Join Our Team!</a
          >
        </v-col>
        <v-col
          class="col-md-1 col-lg-auto pl-lg-0 join-us join-2 hidden-sm-and-down"
        >
          <a
            href="https://renopd.com/cadets"
            style="background-color: #4587c1 !important"
            class="btn waves-effect mr-2 px-2 white--text"
            target="_blank"
            title="Join Jr Cadets"
            >Join &nbsp; Jr. Cadets!</a
          >
        </v-col>
        <!-- END Join buttons md and up -->

        <!-- City of reno logo -->
        <v-col
          cols="2"
          class="col-md-1 col-lg-auto pt-md-5 flex-item-3 pr-0 d-flex flex-row"
        >
          <a
            href="https://www.reno.gov/"
            target="_blank"
            title="City of Reno Home Page"
          >
            <img src="../images/city.png" class=""
          /></a>
        </v-col>
      </v-row>

      <!-- blue bar -->
      <div id="app-title-container" style="width: 100%" class="d-flex">
        <div id="blue-bar" class="my-2">
          <v-row
            id="blue-bar-flex"
            cols="12"
            class="flex-row nowrap justify-space-between align-center pa-2"
          >
            <!-- RPD Home -->
            <v-col cols="5" class="col-md-12 px-0">
              <!-- menu -->
              <rpd_menu></rpd_menu>
            </v-col>
            <!-- <v-col cols="5" class="col-md-2 pt-med-2 px-0"
              ><a
                href="https://renopd.com/"
                title="RPD Home"
                class="white--text"
                >RPD Home</a
              ></v-col
            > -->
            <!--END  RPD Home -->

            <!-- Join buttons mobile -->
            <v-col class="join-buttons btn-1 hidden-md-and-up px-0" cols="3">
              <a
                href="https://renopd.com/Recruit"
                style="background-color: #4587c1 !important"
                class="join-us-mobile btn waves-effect mr-2 px-2"
                target="_blank"
                title="Join Our Team"
                >Join Our Team!</a
              >
            </v-col>
            <v-col class="join-buttons btn-2 hidden-md-and-up px-0" cols="3">
              <a
                href="https://renopd.com/cadets"
                style="background-color: #4587c1 !important"
                class="join-us-mobile btn waves-effect mr-2 px-2"
                target="_blank"
                title="Join Jr. Cadets"
                >Join Jr Cadets!</a
              >
            </v-col>
            <span class="text-h6"></span>
          </v-row>
        </div>

        <v-spacer></v-spacer>
      </div>
    </div>
  </v-container>
</template>

<style scoped>
/* 0 media q */
@media (min-width: 0px) {
  .container {
    padding: 12px 0;
    max-width: 768px;
  }
  /* width: 100%; */
  #v-app-bar--container {
    background-image: url(../images/jm-Header2.png);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    align-items: flex-start;
  }

  .city-header {
    height: 67px;
  }

  .flex-item-1 img {
    width: 53px !important;
  }

  .flex-item-2 {
    line-height: 0.8rem;
    font-size: 12px;
    font-weight: 500;
  }

  .flex-item-3 img {
    width: 25px;
    justify-content: flex-end;
  }

  /* blue bar, join buttons */
  #blue-bar {
    background-color: #002e42 !important;
    color: white !important;
    max-width: 768px;
    width: 100%;
    height: 3.8em;
    text-align: center;
    vertical-align: middle;
    margin-bottom: 25px;
    -webkit-box-shadow: 0px 5px 5px 0px rgba(50, 50, 50, 0.75);
    -moz-box-shadow: 0px 5px 5px 0px rgba(50, 50, 50, 0.75);
    box-shadow: 0px 5px 5px 0px rgba(50, 50, 50, 0.75);
  }

  #blue-bar .join-us-mobile {
    margin-top: 4px;
    width: 105px;
    height: 29px;
    padding-left: 1px;
    padding-right: 1px;
    font-size: 10px;
    line-height: 1.5;
    padding-top: 7px;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 1), 0 2px 10px 0 rgba(0, 0, 0, 1);
  }

  #blue-bar .waves-effect {
    cursor: pointer;
    display: inline-block;
    overflow: hidden;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    vertical-align: middle;
    z-index: 1;
    will-change: opacity, transform;
    transition: all 0.3s ease-out;
  }

  #blue-bar .btn {
    color: #fff;
    letter-spacing: 0.5px;
    text-decoration: none;
    text-align: center;
    border: none;
    border-radius: 2px;
    height: 36px;
    line-height: 36px;
    outline: 0;
    padding: 0 2rem;
    text-transform: uppercase;
    vertical-align: middle;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .city-header {
    height: 97px;
  }

  .flex-item-1 img {
    width: 77px !important;
  }

  .flex-item-2 {
    line-height: 1;
    font-size: 1.2rem !important;
    font-weight: 500;
  }

  .flex-item-3 img {
    width: 35px;
  }

  /* .join-us {

  } */

  .join-us a {
    display: flex;
    width: 60px;
    height: 69px;
    padding-left: 5px;
    font-size: 12px;
    line-height: 1.5;
    padding-top: 7px;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 1), 0 2px 10px 0 rgba(0, 0, 0, 1);
    text-transform: uppercase;
  }

  .join-us .btn {
    border-radius: 2px;
  }

  #blue-bar {
    height: 2.5em;
  }
}

/* ipad lansdscape */
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .container {
    padding: 12px 0;
    width: 100vw;
    max-width: 100vw;
  }

  .city-header {
    height: 130px;
  }

  .flex-item-1 img {
    width: 105px !important;
  }

  .flex-item-2 {
    margin-right: 25px;
    width: 60% !important;
    max-width: 60% !important;
    margin-left: 32px !important;
  }

  .btn-2 {
    padding-left: 0;
  }

  .flex-item-3 img {
    justify-content: center;
  }

  #blue-bar {
    max-width: 100vw;
    width: 100vw;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
  .container {
    padding: 12px 0;
    width: 100vw;
    max-width: 100vw;
  }

  #v-app-bar--container {
    width: 101vw;
    max-width: 101vw;
    background-image: url(../images/jm-Header2.png);
    background-position: center;
    background-size: contain;
    background-repeat: repeat;
    align-items: center;
  }

  .city-header {
    height: 130px;
  }

  .flex-item-1 img {
    width: 105px !important;
  }

  .join-1 {
    margin-left: -53px;
  }

  .flex-item-3 img {
    justify-content: center;
    width: 50px;
  }

  #blue-bar {
    max-width: 100vw;
    width: 100vw;
  }
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
import rpd_menu from "../components/rpd_menu.vue";
export default {
  name: "banner",
  components: { rpd_menu },
  data: function () {
    return {
      brandbar_show: true,
    };
  },

  methods: {},
  mounted() {
    console.log("brand mounted");
    // Build the payload
    const payload = {
      url: window.location.href,
      referrer: document.referrer,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    };

    console.log("track: " + payload.url);

    // Post to your analytics endpoint
    fetch("/Analytics/Track", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }).catch((err) => {
      console.error("Analytics tracking failed:", err);
    });
  },
};
</script>
